import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        padding: theme.spacing(0, 4),
    },
}));
